import { render } from "./Sidebar.ce.vue?vue&type=template&id=2c32a020&scoped=true"
import script from "./Sidebar.ce.vue?vue&type=script&lang=js"
export * from "./Sidebar.ce.vue?vue&type=script&lang=js"

import _style_0 from "./Sidebar.ce.vue?vue&type=style&index=0&id=2c32a020&inline&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-2c32a020"]])

export default __exports__